module.exports = {
	"classes": [
		"tos-page",
		"header-dark"
	],
	"title": "Terms of Service",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/terms/metadata.json
// module id = 1437
// module chunks = 0